import { render } from "./BrandBackground.vue?vue&type=template&id=22c71de4&scoped=true"
import script from "./BrandBackground.vue?vue&type=script&lang=js"
export * from "./BrandBackground.vue?vue&type=script&lang=js"

import "./BrandBackground.css?vue&type=style&index=0&id=22c71de4&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22c71de4"]])

export default __exports__